import { useState } from 'react'

import styles from './index.module.scss'

import reskillingBannerPc from '../../public/reskilling_banner_pc.png'
import reskillingBannerPcDetail from '../../public/reskilling_banner_detail_pc.png'

import reskillingBannerSp from '../../public/reskilling_banner_sp.png'
import reskillingBannerSpDetail from '../../public/reskilling_banner_detail_sp.png'

import reskillingPriceDescriptionDetail from '../../public/reskilling_price_description_detail.png'

type Props = {
  isPc: boolean
}

export const AwardContentReskilling = ({ isPc }: Props) => {
  const [showReskillingBannerDetail, setShowReskillingBannerDetail] =
    useState<boolean>(false)
  const [showPriceDescriptionDetail, setShowPriceDescriptionDetail] =
    useState<boolean>(false)

  const toggleReskillingBannerDetail = () => {
    setShowReskillingBannerDetail(!showReskillingBannerDetail)
  }

  const togglePriceDescriptionDetail = () => {
    setShowPriceDescriptionDetail(!showPriceDescriptionDetail)
  }

  return (
    <div className={styles.container}>
      <div className={styles.reskiliingContainer}>
        <div
          className={`${styles.showDetailToggle} ${
            showReskillingBannerDetail
              ? styles.reskillingBannerDetailOpen
              : styles.reskillingBannerDetailClose
          }`}
          onClick={toggleReskillingBannerDetail}
        ></div>
        {showReskillingBannerDetail ? (
          <>
            <a
              className={styles.linkToPricePageText}
              href="https://shelikes.jp/landing_pages/price"
              target="_blank"
              rel="noreferrer"
            ></a>
            <div
              className={`${styles.showPriceDescriptionDetailToggle} ${
                showPriceDescriptionDetail
                  ? styles.priceDescriptionDetailOpen
                  : styles.priceDescriptionDetailClose
              }`}
              onClick={togglePriceDescriptionDetail}
            ></div>
            <div className={styles.detailImages}>
              <img
                src={
                  isPc
                    ? reskillingBannerPcDetail.src
                    : reskillingBannerSpDetail.src
                }
                alt=""
                className={styles.bannerDetailImage}
              />
              {showPriceDescriptionDetail && (
                <img
                  src={reskillingPriceDescriptionDetail.src}
                  alt=""
                  className={styles.priceDescriptionImage}
                  style={{
                    width: isPc ? '70%' : '90%',
                    height: 'auto',
                    display: 'block',
                    margin: '0 auto',
                  }}
                />
              )}
            </div>
          </>
        ) : (
          <img
            src={isPc ? reskillingBannerPc.src : reskillingBannerSp.src}
            alt=""
          />
        )}
      </div>
    </div>
  )
}
